import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { TrackingView } from '@/components/solicitacao/tracking-view'
import { useSolicitacaoDetails } from '@/hooks/useSolicitacaoDetails'
import { useSolicitacaoUpdates } from '@/hooks/useSolicitacaoUpdates'
import { extractOrderId } from '@/lib/utils'

export const Route = createFileRoute('/app/entregas/$entregaId/acompanhar')(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {
  const { entregaId: rawId } = Route.useParams()
  const navigate = useNavigate()
  const entregaId = Number(extractOrderId(rawId))

  useEffect(() => {
    if (!entregaId || isNaN(entregaId)) {
      navigate({ to: '/app/entregas' })
    }
  }, [entregaId, navigate])

  function handleGoBack() {
    navigate({
      to: '/app/entregas/$entregaId',
      params: { entregaId: String(entregaId) },
    })
  }

  const { solicitacao, isLoading, error } = useSolicitacaoDetails(entregaId)

  useSolicitacaoUpdates(solicitacao?.updateChannel, entregaId)

  return (
    <TrackingView
      solicitacao={solicitacao!}
      isLoading={isLoading}
      error={error!}
      onBack={handleGoBack}
    />
  )
}
